import { DcmDocumentListQuery } from "../interfaces/DcmDocumentListConfiguration";

export class QueryParserService {
  public static queryToString(query: DcmDocumentListQuery): string {
    const stringQuery =
      this.getSelectQuery(query) +
      this.getFromQuery(query) +
      this.getJoinQuery(query) +
      this.getWhereQuery(query) +
      this.getOrderByQuery(query);
    return stringQuery;
  }

  private static getSelectQuery(query: DcmDocumentListQuery): string {
    let selectQuery = `SELECT `;
    let prefix = ``;
    for (const selector of query.select) {
      selectQuery += `${prefix}${selector.value}`;
      prefix = `, `;
    }
    selectQuery += ` `;
    return selectQuery;
  }

  private static getFromQuery(query: DcmDocumentListQuery): string {
    return `FROM ${query.from.value} ${query.from.as ? `AS ${query.from.as} ` : ``}`;
  }

  private static getJoinQuery(query: DcmDocumentListQuery): string {
    let joinQuery = ``;
    if (query.join) {
      for (const join of query.join) {
        joinQuery += `${join.type != null ? `${join.type} ` : ``}JOIN ${join.value}${
          join.as != null ? ` AS ${join.as} ` : ``
        }ON ${join.on[0]} = ${join.on[1]} `;
      }
    }
    return joinQuery;
  }

  private static getWhereQuery(query: DcmDocumentListQuery): string {
    let whereQuery = ``;
    if (query.where && query.where.length > 0) {
      whereQuery += `WHERE `;
      let prefix = ``;
      for (const where of query.where) {
        whereQuery += `${prefix}(${this.applyWhere(where)}) `;
        prefix = `AND `;
      }
    }
    return whereQuery;
  }

  private static applyWhere(where: any): string {
    let whereQuery = ``;
    let prefix = `'`;
    switch (where.operator) {
      case `=`:
        return `${where.key} = '${where.value}'`;
      case `LIKE`:
        return `${where.key} LIKE '%${where.value}%'`;
      case `BETWEEN`:
        if (where.value.from) {
          whereQuery += `${where.key} >= '${where.value.from}'`;
          if (where.value.to) {
            whereQuery += ` AND `;
          }
        }
        if (where.value.to) {
          whereQuery += `${where.key} <= '${where.value.to}'`;
        }
        return whereQuery;
      case `IN`:
        whereQuery += `${where.key} IN(`;
        for (const value of where.value) {
          whereQuery += `${prefix}${value}'`;
          prefix = `,'`;
        }
        whereQuery += `)`;
        return whereQuery;
      default:
        return ``;
    }
  }

  private static getOrderByQuery(query: DcmDocumentListQuery): string {
    let orderByQuery = ``;
    if (query.orderBy && query.orderBy.length > 0) {
      orderByQuery += `ORDER BY `;
      let prefix = ``;
      for (const orderBy of query.orderBy) {
        orderByQuery += `${prefix}${orderBy.value} ${orderBy.desc ? `DESC` : `ASC `}`;
        prefix = `, `;
      }
    }
    return orderByQuery;
  }
}
